import { axiosInstance, downloadBlobDataFile } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostLotLedgersExcelDownloadParams } from '~/types/stock.types';

/**
 * 재고관리 - 재고수불부(KLS) 엑셀 다운로드 API
 */
const usePostLotLedgersExcelDownload = () => {
  const endpoint = '/api-inventory-agg/v1/lot-ledgers/excel-download';

  const postLotLedgersExcelDownload = async (params: TypePostLotLedgersExcelDownloadParams) => {
    return axiosInstance
      .post<Blob>(endpoint, params, { responseType: 'blob' })
      .then(async (data) => {
        const responseString = await data.data.text();
        const isNoDataError = responseString.includes('데이터가 존재하지 않습니다.');

        if (isNoDataError) {
          const parsedResponse = JSON.parse(responseString);

          throw new Error(parsedResponse.error.message);
        }

        downloadBlobDataFile(data);
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postLotLedgersExcelDownload };
};

export default usePostLotLedgersExcelDownload;
